import React, { useState, Fragment } from "react";
import { Image, Button, Modal } from "react-bootstrap";

// import OrderDescModelBody from "./OrderDescModelBody";
import EditModelBody from "./EditModelBody";
// import OrderLocation from "./OrderLocation";
import { Toggle } from "../../../superAdminComponents/superAdminReusable/reusableSuperAdminButton/Toggle";

import { SET_ACTIVE_CATEGORY_DATA_MENU_SETUP } from "../../../../store/types";
import { useHistory } from "react-router-dom";
import { get_category_menu_setup } from "../../../../store/actions/VendorSubscriptionAction/vendorSubscriptionGetAction";
import {
  delete_category_menu_setup,
  edit_category_menu_setup,
} from "./../../../../store/actions/VendorSubscriptionAction/vendorSubscriptionPostAction";
import { connect, useDispatch } from "react-redux";
import PropTypes from "prop-types";

export const TableBody = (props) => {
  let history = useHistory();
  const dispatch = useDispatch();
  const [TrDetail, setTrDetail] = useState({ TrDetail: false });
  const showTr = () => setTrDetail({ TrDetail: !TrDetail.TrDetail });

  const takeToCategoryEditPage = (data) => {
    dispatch({ type: SET_ACTIVE_CATEGORY_DATA_MENU_SETUP, payload: data });
    history.push("/addcategory");
  };

  //Model order view
  const [MrDetail, setMrDetail] = useState({ MrDetail: false });
  const viewOrderInDetail = () => setMrDetail({ MrDetail: !MrDetail.MrDetail });

  const [vtype, viewType] = useState(1);

  const [showCategory, setShowCategory] = useState(false);
  const handleCloseShowCategory = () => {
    setShowCategory(false);
  };
  const handleShowCategory = () => {
    setShowCategory(true);
  };

  const onSuccess = () => {
    props.get_category_menu_setup(props.token);
    setShowCategory(false);
  };

  const onClickDeleteCategory = () => {
    props.delete_category_menu_setup(
      props.category._id,
      props.token,
      onSuccess
    );
  };

  const changeStatus = (status) => {
    const formData = {};
    if (status === undefined) {
      formData.status = false;
    } else {
      formData.status = !status;
    }
    props.edit_category_menu_setup(
      props.category._id,
      formData,
      props.token,
      onSuccess,
      "Status Updated Sucessfully"
    );
  };

  return (
    <React.Fragment>
      {console.log(props.category)}
      <tbody
        className="w-100 super-admin-all-vendor-main-table-body"
        style={{ fontSize: "12px" }}
      >
        <tr className="w-100 p-0" style={{ wordBreak: "break-word" }}>
          <td className="p-0 w-100">
            <table className="w-100">
              <tbody className="sd_body_css">
                <tr
                  className="sd_body_table-row"
                  // style={{ textAlign: "center" }}
                  onClick={showTr}
                >
                  <td style={{ width: "25%" }}>
                    #ID
                    {props.category && props.category._id}
                    <br />
                    {/* <img
                      src={require("../../../../assets/images/Orders/Mask Group 113.png")}
                      width="35px"
                    /> */}
                  </td>
                  <td style={{ width: "20%" }}>
                    {props.category && props.category.name}
                  </td>
                  <td style={{ width: "10%" }}>
                    {" "}
                    {props.category &&
                      props.category.items &&
                      props.category.items.length}
                  </td>
                  {console.log(props.category)}
                  <td style={{ width: "20%" }}>
                    {props.category.cross_selling.category.length > 0 ? (
                      <>
                        {" "}
                        {props.category.cross_selling.category.map(
                          (item, index) => (
                            <Fragment key={index}>{item.name} </Fragment>
                          )
                        )}
                      </>
                    ) : (
                      "N/A"
                    )}
                  </td>
                  <td
                    style={{ width: "15%" }}
                    onClick={(e) => {
                      if (!e) var e = window.event;
                      e.cancelBubble = true;
                      if (e.stopPropagation) e.stopPropagation();
                    }}
                  >
                    <div className="d-flex align-items-center">
                      Active
                      <Toggle
                        checked={
                          props.category && props.category.status === undefined
                            ? true
                            : props.category && props.category.status
                            ? true
                            : false
                        }
                        toggleFunction={() =>
                          changeStatus(props.category.status)
                        }
                      />
                    </div>
                  </td>

                  <td style={{ width: "20%" }}>
                    <div
                      className="badge badge-danger"
                      style={{ padding: "5px 25px", borderRadius: "15px" }}
                    >
                      Soldout
                    </div>
                  </td>
                </tr>
                {TrDetail.TrDetail && (
                  <tr
                    className="sd_accordion_body"
                    style={{ background: "#ffffff" }}
                  >
                    <div className="container-fluid">
                      <hr style={{ margin: 0 }} />
                      <div className="row" style={{ alignItems: "center" }}>
                        <div
                          className="col-3"
                          style={{ borderRight: "1px solid #E0E0E0" }}
                        >
                          <h6>More actions</h6>
                          <br />
                          <br />
                          <div className="more-actions-orders-desc d-flex align-items-center  mb-2">
                            {/* <SuperAdminCall /> */}
                            <ViewCategoryModal
                              takeToCategoryEditPage={() =>
                                takeToCategoryEditPage(props.category)
                              }
                              handleShowCategory={handleShowCategory}
                            />
                            <Button
                              variant="link"
                              className="enIconBtn mr-3"
                              // onClick={() => {
                              //   viewType(2);
                              //   viewOrderInDetail();
                              // }}
                              onClick={() =>
                                takeToCategoryEditPage(props.category)
                              }
                            >
                              <Image
                                src={require("../../../../assets/images/UserManagement/pencil.svg")}
                                alt="Edit category"
                                title="Edit category"
                                fluid
                              />
                            </Button>{" "}
                            <Button
                              variant="link"
                              className="enIconBtn mr-3"
                              // onClick={() => {
                              //   viewType(1);
                              //   viewOrderInDetail();
                              // }}
                              onClick={() => handleShowCategory()}
                            >
                              <i
                                className="fa fa-trash"
                                style={{ color: "#000000" }}
                                title="Delete"
                              ></i>
                            </Button>
                            {/* <CustomSuperAdminNotification
                              _id={"5f84b0d7741561060859ee1f"}
                            /> */}
                          </div>
                        </div>

                        <div className="col-8">
                          <h6>Description</h6>
                          <p> {props.category && props.category.description}</p>
                        </div>
                      </div>
                    </div>
                  </tr>
                )}
                <div>
                  <Modal
                    show={MrDetail.MrDetail}
                    onHide={() => {
                      viewOrderInDetail();
                    }}
                    centered
                    size="md"
                  >
                    <Modal.Header className="border-0 pl-4" closeButton>
                      <Modal.Title className="f24-700">
                        Item Availability
                        {/* {vtype === 2 && "Substitute Item"}
                        // {vtype === 3 && "User Location"} */}
                      </Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="p-4 f16-500">
                      <div className="">
                        {/* {/* {vtype === 1 && <OrderDescModelBody />} */}
                        <EditModelBody />
                        {/* {vtype === 3 && <OrderLocation />} */}
                      </div>
                      {/* <EditUser
                            data={currentUserData}
                            CloseEdit={handleCloseEdit}
                          /> */}
                    </Modal.Body>
                  </Modal>
                </div>
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
      <React.Fragment>
        <Modal show={showCategory} onHide={handleCloseShowCategory} centered>
          <Modal.Header className="py-0 pt-2 border-0" closeButton>
            <Modal.Title></Modal.Title>
          </Modal.Header>
          <Modal.Body className="f16-500">
            Are you sure to delete this category ?
          </Modal.Body>
          <Modal.Footer className="justify-content-start border-0">
            <Button
              variant="outline-secondary"
              className="btn-lg mr-4 px-5"
              onClick={handleCloseShowCategory}
            >
              No
            </Button>
            <Button
              variant="danger"
              className="btn-lg px-5"
              // onClick={handleCloseBlockUser}
              onClick={() => onClickDeleteCategory()}
            >
              Yes
            </Button>
          </Modal.Footer>
        </Modal>
      </React.Fragment>
    </React.Fragment>
  );
};

TableBody.propTypes = {
  auth: PropTypes.object.isRequired,
  edit_category_menu_setup: PropTypes.func.isRequired,
  get_category_menu_setup: PropTypes.func.isRequired,
  delete_category_menu_setup: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors && state.errors.errors,
  menuCategoryItems: state.onboarding && state.onboarding.menuCategoryItems,
});

export default connect(mapStateToProps, {
  delete_category_menu_setup,
  get_category_menu_setup,
  edit_category_menu_setup,
})(TableBody);

const ViewCategoryModal = (props) => {
  const [viewModal, setViewModal] = useState(false);
  const handleCloseShowCategory = () => setViewModal(false);
  return (
    <React.Fragment>
      <Button
        variant="link"
        className="enIconBtn mr-3"
        onClick={() => {
          setViewModal(true);
        }}
      >
        <Image
          src={require("../../../../assets/images/UserManagement/eye.svg")}
          alt="View"
          title="View"
          fluid
        />
      </Button>
      <Modal
        show={viewModal}
        // size="lg"
        onHide={handleCloseShowCategory}
        centered
      >
        <Modal.Header className="py-0 pt-2 border-0" closeButton>
          <Modal.Title>Category Dashboard</Modal.Title>
        </Modal.Header>
        <Modal.Body className="f16-500">
          <div className="row mt-2">
            <div className="col-3">
              <div className="f12-400">Category Id</div>
            </div>
            <div className="col-3">
              <div className="f12-400">Category Name</div>
            </div>
            <div className="col-3">
              <div className="f12-400">No. Of Items</div>
            </div>
            <div className="col-3">
              <div className="f12-400">Cross Selling Categories</div>
            </div>
          </div>
          <div className="row mt-2">
            <div className="col-3">
              <div className="f14-500">#ID123456</div>
            </div>
            <div className="col-3">
              <div className="f14-500">Soup</div>
            </div>
            <div className="col-3">
              <div className="f14-500">10</div>
            </div>
            <div className="col-3">
              <div className="f14-500">Alcohol; Beverages; Juice</div>
            </div>
          </div>
          <div className="row mt-3">
            <div className="col-7">
              <div className="f12-400">Description</div>
            </div>
            <div className="col-5">
              <div className="f12-400">More Actions</div>
            </div>
          </div>
          <div className="row mt-3">
            <div className="col-7">
              Tomato fillet, basil
              <br />
              olive oil
            </div>
            <div className="col-5">
              <div classname="d-flex align-items-center">
                <Button
                  variant="link"
                  className="enIconBtn mr-3"
                  // onClick={() => {
                  //   viewType(2);
                  //   viewOrderInDetail();
                  // }}
                  onClick={() => {
                    props.takeToCategoryEditPage();
                    handleCloseShowCategory();
                  }}
                >
                  <Image
                    src={require("../../../../assets/images/UserManagement/pencil.svg")}
                    alt="Edit category"
                    title="Edit category"
                    fluid
                  />
                </Button>{" "}
                <Button
                  variant="link"
                  className="enIconBtn mr-3"
                  // onClick={() => {
                  //   viewType(1);
                  //   viewOrderInDetail();
                  // }}
                  onClick={() => {
                    props.handleShowCategory();
                    handleCloseShowCategory();
                  }}
                >
                  <i
                    className="fa fa-trash"
                    style={{ color: "#000000" }}
                    title="Delete"
                  ></i>
                </Button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};
